import { argbFromHex as m, redFromArgb as p, greenFromArgb as f, blueFromArgb as E, Hct as h, hexFromArgb as T, TonalPalette as R } from "@material/material-color-utilities";
import { NEUTRAL_SEED_COLOR_CHROMA as _, FIXED_NEUTRAL_MONOCHROME_SEED_COLOR as y, FIXED_UTILITY_SEED_COLORS as e, LIGHT_THEME_ASSIGNMENTS as l, DARK_THEME_ASSIGNMENTS as F } from "./consts.js";
function O(t) {
  const a = m(t);
  return {
    r: p(a),
    g: f(a),
    b: E(a),
    a: 1
  };
}
function L(t, a) {
  const u = m(t);
  return {
    r: p(u),
    g: f(u),
    b: E(u),
    a
  };
}
function v(t) {
  return `rgba(${t.r}, ${t.g}, ${t.b}, ${t.a})`;
}
function N(t) {
  const { r: a, g: u, b, a: g } = t, o = a.toString(16).padStart(2, "0"), i = u.toString(16).padStart(2, "0"), c = b.toString(16).padStart(2, "0");
  if (g === 1) return "#" + o + i + c;
  const S = Math.round(g * 255).toString(16).padStart(2, "0");
  return "#" + o + i + c + S;
}
function r(t, a) {
  return T(
    R.fromInt(m(a)).tone(
      parseInt(t)
    )
  );
}
function n(t) {
  return {
    100: r("100", t),
    99: r("99", t),
    98: r("98", t),
    95: r("95", t),
    90: r("90", t),
    80: r("80", t),
    70: r("70", t),
    60: r("60", t),
    50: r("50", t),
    40: r("40", t),
    35: r("35", t),
    30: r("30", t),
    27: r("27", t),
    25: r("25", t),
    20: r("20", t),
    14: r("14", t),
    10: r("10", t),
    0: r("0", t)
  };
}
function w(t) {
  const a = h.fromInt(m(t.primary));
  a.chroma = _;
  const u = T(a.toInt());
  return {
    ...t,
    neutral: u,
    neutralMono: y,
    ...e
  };
}
function D() {
  return {
    neutralMono: n(
      y
    ),
    magenta: n(
      e.magenta
    ),
    violet: n(
      e.violet
    ),
    blue: n(e.blue),
    azure: n(e.azure),
    cyan: n(e.cyan),
    green: n(e.green),
    chartreuse: n(
      e.chartreuse
    ),
    yellow: n(
      e.yellow
    ),
    orange: n(
      e.orange
    ),
    pink: n(e.pink)
  };
}
function G(t) {
  return {
    primary: n(t.primary),
    success: n(t.success),
    warning: n(t.warning),
    error: n(t.error),
    premium: n(t.premium),
    neutral: n(t.neutral),
    neutralMono: n(t.neutralMono),
    magenta: n(t.magenta),
    violet: n(t.violet),
    blue: n(t.blue),
    azure: n(t.azure),
    cyan: n(t.cyan),
    green: n(t.green),
    chartreuse: n(t.chartreuse),
    yellow: n(t.yellow),
    orange: n(t.orange),
    pink: n(t.pink)
  };
}
function k(t, a, u) {
  const g = {
    ...a === "light" ? l : F,
    ...u
  };
  return Object.keys(g).reduce(
    (i, c) => {
      const S = g[c][0], A = g[c][1];
      return {
        ...i,
        [c]: t[S][A]
      };
    },
    {}
  );
}
export {
  N as RGBAToHex,
  v as RGBAToString,
  O as baseColorHexToRGBA,
  n as generateContrastRangeFromSeedColor,
  G as generatePaletteFromSeedColors,
  w as generateSeedColorsFromVariableSeedColors,
  k as generateThemeColorsFromPalette,
  D as generateUtilityColorsContrastRange,
  L as overlayColorHexToRGBA
};
